import React from 'react'
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded'
import { formatDateTime, getPaginatedItems } from '../../utils/apiData'
import { getApplicationCode, getApplicationsFromSession } from '../../utils/permisos'
import { ApplicationIcon } from '../../components/applications/ApplicationIcon'
import { getUserAuditEvents, getUserSessions } from './userDashboardApi'

const ignoredActivityModules = ['logistics', 'flujos']

export const getUserPanelApplicationIcon = (application) => {
  return <ApplicationIcon application={application} size={36} />
}

export const getPrimaryApplicationCode = (session) => {
  const applications = getApplicationsFromSession(session)
  const suiteHome = applications.find((access) => getApplicationCode(access).toUpperCase() === 'SUITE_HOME')
  return getApplicationCode(suiteHome || applications[0])
}

const formatAuditAction = (value) => String(value || 'Actividad registrada')
  .toLowerCase()
  .replace(/_/g, ' ')
  .replace(/^\w/, (letter) => letter.toUpperCase())

const mapAuditEventToActivity = (event) => ({
  app: event.applications?.name || event.application?.name || event.applicationCode || event.module || 'Clasol Suite Apps',
  module: event.module || '-',
  date: formatDateTime(event.created_at || event.createdAt, 'Sin fecha'),
  action: formatAuditAction(event.action),
  icon: getUserPanelApplicationIcon({ code: event.applicationCode || event.module, title: event.module }),
})

const mapSessionToActivity = (session) => ({
  app: 'Clasol Suite Apps',
  module: 'auth',
  date: formatDateTime(session.last_used_at || session.lastUsedAt || session.created_at || session.createdAt, 'Sin fecha'),
  action: session.revoked_at || session.revokedAt ? 'Sesión cerrada' : 'Sesión activa',
  icon: <AccessTimeRoundedIcon />,
})

export const getUserRecentActivity = async ({ session, userId, limit = 5 }) => {
  try {
    const applicationCode = getPrimaryApplicationCode(session)
    if (!applicationCode) throw new Error('Sin aplicacion para consultar auditoria.')

    const response = await getUserAuditEvents(applicationCode, {
      userId,
      page: 1,
      limit,
      sortDirection: 'desc',
    })
    const auditRows = getPaginatedItems(response)
      .filter((event) => !ignoredActivityModules.includes(String(event.module || '').toLowerCase()))
      .map(mapAuditEventToActivity)

    if (auditRows.length > 0) return auditRows
  } catch {
    // Falls back to real auth session history below.
  }

  const sessionsResponse = await getUserSessions()
  return getPaginatedItems(sessionsResponse)
    .slice(0, limit)
    .map(mapSessionToActivity)
}
